import { Box } from '@mui/material';
import { Children } from 'react';
import { meryville } from 'util/themes';

interface ITableExpandedRow {
    isExpanded: boolean;
    rows: IExpandedRowValue[];
    isLastRow: boolean;
}

interface IExpandedRowValue {
    key: string;
    value: string;
}

const styles = {
    parent: {
        backgroundColor: meryville.palette.grey[100],
        borderColor: meryville.palette.grey[300],
        borderTop: 0,
        borderBottom: `1px solid ${meryville.palette.grey[300]}`,
        height: 'inherit',
        boxShadow: '0 1px #e3e8ee inset',
    },
    keyStyle: {
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '24px',
        flexBasis: '13%',
        marginRight: 1,
    },
    valueStyle: {
        fontSize: '16px',
        lineHeight: '24px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        p: 1,
    },
    container: {
        p: 4,
        gap: 2,
    },
};

export function TableExpandedRow(props: ITableExpandedRow) {
    const { isExpanded, rows, isLastRow } = props;
    if (!isExpanded) {
        return <></>;
    }
    const lastRowOverrides: any = {};
    if (isLastRow) {
        lastRowOverrides.borderRadius = '0 0 12px 12px';
        lastRowOverrides.borderBottom = 'none';
    }
    return (
        <Box sx={{ ...styles.parent, ...lastRowOverrides }}>
            <Box sx={{ ...styles.container, ...lastRowOverrides }}>
                {Children.toArray(
                    rows.map((x: IExpandedRowValue) => {
                        return (
                            <Box sx={styles.row}>
                                <Box sx={styles.keyStyle}>{x.key}</Box>
                                <Box sx={styles.valueStyle}>{x.value}</Box>
                            </Box>
                        );
                    })
                )}
            </Box>
        </Box>
    );
}
